import { useState } from 'react'
import { modal, ModalParams } from '@codeleap/modals'
import { ChatChannel } from '@packages/chat'
import { NewChat, AddMembers, NewGroup } from './components'

const pages = [NewChat, AddMembers, NewGroup]

const MoldaContent = (modalProps: ModalParams<{}, ChatChannel>) => {
  const [page, setPage] = useState(0)

  const CurrentPage = pages[page]

  function nextPage() {
    setPage((prev) => Math.min(prev + 1, pages.length - 1))
  }

  function prevPage() {
    setPage((prev) => Math.max(prev - 1, 0))
  }

  return <CurrentPage {...modalProps} onNextPage={nextPage} onPrevPage={prevPage} />
}

export const NewChatModal = modal<{}, ChatChannel>().content(MoldaContent).props({
  showClose: false,
  style: [
    'centered', 'box:responsiveness', 
    { box: ['padding:0', { breakpoints: { tabletSmall: ['padding:0'] } }] }
  ],
})
